// UserInfoModal.tsx
import {Button, Descriptions, message, Modal} from 'antd';
import {useAppDispatch, useAppSelector} from '../hooks'; // ✅ typed hook
import {logout, patchAvatarIndex, updateAvatarIndex} from '../features/user/userSlice';
import {RootState} from "../store";
import {useFirm} from '../hooks/useFirm';
import React from "react";
import PortraitSelect from "../components/PortraitSelect"; // <-- ajoute l'import

interface Props {
    open: boolean;
    onClose: () => void;
}

const UserInfoModal = ({open, onClose}: Props) => {
    const userState = useAppSelector((state: RootState) => state.user);
    const {user} = useAppSelector((state: RootState) => state.user);
    const firm = useFirm();
    const dispatch = useAppDispatch();

    // index par défaut : prends-le depuis ton modèle si dispo (ex: user.avatarIndex)
    const initialAvatarIndex = (userState?.user as any)?.avatarIndex ?? 0;

    const handleLogout = () => {
        localStorage.removeItem('user');
        dispatch(logout());
        onClose();
        window.location.reload();
    };

    const handleAvatarChange = (index: number) => {
        const previousIndex: number = user?.avatarIndex ?? 0; // <-- declare it here

        console.log('Updating avatar index:', index, 'previous was:', previousIndex);
        dispatch(updateAvatarIndex(index));
        dispatch(patchAvatarIndex(index)).unwrap()
            .then(() => {
                void message.success(`Avatar mis à jour (${index})`);
            })
            .catch((err) => {
                return message.error(`Échec de la mise à jour de l'avatar, veuillez réessayer (${err.message})`);
            });
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            title="Mon compte - Informations personnelles"
            width={900}                 // un peu plus large pour le bloc avatar 200x200
        >
            {/* Ligne principale : infos à gauche, PortraitSelect à droite */}
            <div style={{display: "flex", gap: 24, alignItems: "flex-start"}}>
                <div style={{flex: 1, minWidth: 0}}>
                    <Descriptions column={1} bordered size="small">
                        <Descriptions.Item label="Nom d'utilisateur">{userState?.user?.username}</Descriptions.Item>
                        <Descriptions.Item label="Prénom">{userState?.user?.firstName}</Descriptions.Item>
                        <Descriptions.Item label="Nom">{userState?.user?.lastName}</Descriptions.Item>
                        <Descriptions.Item label="email">{userState?.user?.email}</Descriptions.Item>
                        <Descriptions.Item label="Firme">{firm?.name}</Descriptions.Item>
                    </Descriptions>
                </div>

                {/* Colonne droite : aperçu cliquable + Select invisible */}
                <div style={{width: 200, flex: "0 0 200px"}}>
                    <PortraitSelect
                        initialValue={initialAvatarIndex}
                        onSelect={handleAvatarChange}
                    />
                </div>
            </div>

            <Button type="primary" danger block style={{marginTop: 20}} onClick={handleLogout}>
                Se déconnecter
            </Button>
        </Modal>
    );
};

export default UserInfoModal;
